import '@babel/polyfill';
import 'whatwg-fetch';

import { Bridge } from '@nackle/bridge';
// Routing
import { Route, routeHistory } from '@nackle/biw-web-router';
// import { useLocation } from 'react-router-dom';
import React from 'react';
import { render } from 'react-dom';
import { Provider, connect } from 'react-redux';
import { default as appAuth, authRouteMiddleware } from './app-auth';
import { getMiddleware as getRouteMiddleware, routes } from './app-routing.jsx';
import PropTypes from 'prop-types';
import { setLanguageBundle } from '@nackle/intl-tools';

// Dux
import AppStore from './app-store';
import { actions } from './app-dux/company-dux.js';

import LoadingOverlay from './components/shared/loader/loading-overlay.jsx';
import ErrorBoundary from './components/shared/error/error.jsx';
import NackleMenu from '@nackle/menu';
import { Layout } from '@nackle/paper';
const { Content } = Layout;

//studio tools layouts
import {
    AppHeader,
    AppFooter,
    ActivityIndicator,
    CMXService
} from '@nackle/studio-tools';

import './styles/style.less';

import confetti from 'canvas-confetti';

const UNLOCK_TEXT = 'tangissuperawesome';

class App extends React.Component {

    constructor( props ) {
        super( props );
        this.state = {
            auth: {},
            user: {},
            unlock: '',
            languageBundleFetched: false
        };
    }
    componentDidMount() {
        window.addEventListener( 'keydown', this.captureKey );
    }
    handlePermissionChange = async( authState ) => {
        this.setState( {
            auth: authState,
            user: authState.claims,
            access_token: authState.access_token,
            permissions: authState.claims.permissions[ 'permissions-manager' ] || []
        } );

        const cmxService = new CMXService( authState );
        const bundle = await cmxService.getBundle( [ 'navigation', 'studio-in-context-help' ], 'en-US' );


        await setLanguageBundle( 'en-US', bundle );
        this.setState( {
            languageBundleFetched: true
        } );

    };
    captureKey = ( event ) => {
        const { unlock } = this.state;

        let updatedUnlock = '';
        if ( unlock !== UNLOCK_TEXT ) {
            updatedUnlock = `${ unlock }${ event.key }`;
        } else {
            return;
        }
        if ( updatedUnlock.indexOf( UNLOCK_TEXT ) >= 0 ) {
            updatedUnlock = UNLOCK_TEXT;
        }

        if ( updatedUnlock === UNLOCK_TEXT ) {
            window.addEventListener( 'click', this.confettiClick );
            this.setState( {
                unlock: updatedUnlock
            } );
        } else {
            this.setState( {
                unlock: updatedUnlock
            } );
        }
    };
    confettiClick = () => {
        const random = ( min, max ) => Math.random() * ( max - min ) + min;
        const doc = document.documentElement;
        let x = event.clientX / doc.clientWidth;
        let y = event.clientY / doc.clientHeight;
        confetti( {
            angle: random( 55, 125 ),
            spread: 360,
            particleCount: 300,
            origin: { x, y }
        } );
    };
    handleCompanyChange = async ( company ) => {
        const route = window.location.pathname;
        const slashIndex = route.indexOf( '/', route.indexOf( '/' ) + 1 );
        const basePath = route.substring( slashIndex );
        this.setState( { activeCompanyId: company.id } );
        if ( route?.match ) {
            routeHistory.replace(
                `/${ company.id }${ basePath }`
            );
        } else {
            routeHistory.push( `/${ company.id }/roles` );
        }
    };

    render() {
        const {
            user,
            permissions,
            access_token
        } = this.state;
        return (
            <ErrorBoundary>
                <Route render={ ( route ) => {

                    return (
                        <Bridge auth={ appAuth } onAuthStateChange={ this.handlePermissionChange }>
                        { this.state.languageBundleFetched ? (
                            <Layout className="root-layout">
                                <AppHeader
                                    auth={ appAuth }
                                    companySelectDisabled={ false }
                                    companyId={ route?.state?.params?.companyId }
                                    onCompanyChange={ this.handleCompanyChange }
                                />
                                {
                                    route.match ?
                                    <Layout>
                                        <Layout>
                                            {
                                                route.match.sidebar &&
                                                <NackleMenu
                                                    auth={ appAuth }
                                                    cmxBundleLoaded={ this.state.languageBundleFetched }
                                                    />
                                            }
                                            <Layout className="page-layout">
                                                <Content className="app-content">
                                                    {
                                                        permissions && Object.entries( permissions ).length !== 0 ?
                                                            <LoadingOverlay loading={ this.props.loading } >
                                                                <div className="content-container">
                                                                    { React.cloneElement( route.component, { userPermissions: permissions, user: user, access_token: access_token, activeCompanyId: this.props.activeCompanyId, auth: this.state.auth } ) }
                                                                </div>
                                                            </LoadingOverlay>
                                                            :
                                                            <h1>Access Denied</h1>
                                                    }
                                                </Content>
                                                <AppFooter />
                                            </Layout>
                                        </Layout>
                                    </Layout>

                                    :
                                    route.pathname && <ErrorBoundary error="path" />
                                }
                            </Layout> ) : <ActivityIndicator />
                        }
                        </Bridge>
                    );
                } } />
            </ErrorBoundary>
        );
    }
}

App.propTypes = {
    loading: PropTypes.bool
};


App = connect(
    // mapStateToProps
    ( state, props ) => {
        return {
            loading: state.app.loading,
            logo: state.company.activeCompany.logo,
            activeCompanyId: state.company.activeCompanyId
        };
    },
    // mapDispatchToProps
    {
        ...actions
    }
)( App );

routeHistory.applyRoutes( routes );
routeHistory.applyMiddleware( getRouteMiddleware( AppStore ), authRouteMiddleware );


render(
    <Provider store={ AppStore }>
        <App />
    </Provider>,
    document.getElementById( 'app-root' )
);
